/**
 * Created by mauget on 1/20/16.
 */

import $                        from 'jquery';
import { Model }           from 'backbone';
import eventBus                 from 'EventBus';
import listService              from 'ListService';
import contentTemplate          from 'designer/behavior-menu.ejs';
import crudController           from 'CrudController';
import pageCaptureController    from 'PageCaptureController';
import constants                from 'Constants';
import BaseMenuView             from 'BaseMenuView';
import CloseFormConfirmationModalView   from 'common-views/CloseFormConfirmationModalView';
import undoService              from 'UndoService';
import alignmentController      from 'AlignmentController';
import userService              from 'UserService';
import HelpCenterView  	        from 'HelpCenterView';
import util                     from 'util/Util';
import objectUtil               from 'util/ObjectUtil';
import notificationService      from 'NotificationService';
import formService from 'FormService';


//=================================================================================================
//
// An instance forms BackBone view of the menubar used atop the various layout panels.
//
// Lou Mauget, January 20, 2016
//
//=================================================================================================
class BehaviorMenuView extends BaseMenuView {

    initialize( opts ) {
        this.options = opts || {};

        this.template   = contentTemplate;

        // Click the three main views navigable within the normal designer main.
        // (Reports entered from the Dashboard)
        this.events = {
            'click #btnEditor'      : 'gotoEditor',
            'click #btnBehaviors'   : 'gotoBehaviors',
            'click #btnWorkflow'    : 'gotoWorkflow',
            'click #designerGrid'   : 'showGrid',
            'click #designerClose'  : 'close',
            'click #designerSave'   : 'saveForm',
            'click #designerSaveNewVersion' : 'saveFormNewVersion',
            'click #designerSaveNewForm'    : 'saveFormAsNew',
            'click #designerPublish'        : 'publish',
            'click #designerCopy'   : 'copyItem',
            'click #designerCut'    : 'cutItem',
            'click #designerPaste'  : 'pasteItem',
            'click #designerUndo'   : 'undo',
            'click #designerRedo'   : 'redo',
            'click #designerDelete' : 'deleteItem',
            'click #designerSelectAll'  : 'selectAll',
            'click #designerPreview'        : 'preview',
            'click #designerDebug'        : 'debug',
            'click #designerReportSave'           : 'saveReport',
            'click #designerReportSaveNewVersion' : 'saveReportNewVersion',
            'click #designerReportSaveNewForm'    : 'saveReportAsNew',
            'click #designerReportPreview'        : 'preview',
            'click #designerAlignTop'   : 'alignTopHandler',
            'click #designerAlignRight' : 'alignRightHandler',
            'click #designerAlignBottom': 'alignBottomHandler',
            'click #designerAlignLeft'  : 'alignLeftHandler',
            'click #designerVerticalCenter'  : 'alignVerticalCenterHandler',
            'click #designerHorizontalCenter'  : 'alignHorizontalCenterHandler',
            'click #designerSameWidth'  : 'makeSameWidthHandler',
            'click #designerSameHeight' : 'makeSameHeightHandler',
            'click #designerSameSize'   : 'makeSameSizeHandler',
            'click #designerSpaceEvenlyAcross': 'spaceEvenlyAcrossHandler',
            'click #designerSpaceEvenlyDown' :  'spaceEvenlyDownHandler',
            'click #designerSpaceEvenlyBoth' :  'spaceEvenlyBothHandler',
            
            'click #hideGrid':'toggleGridVisibility',
            'click #designerNonVisualObjects':'designerNonVisualObjects',
            'click #designerWorkflowMarkers':'designerWorkflowMarkers',
            'click #designerObjectMarkers':'designerObjectMarkers',
            'click #designerSnapToGrid':'toggleSnapToGrid',
            'click #designerSnapTextToNeighbor':'designerSnapTextToNeighbor',
            'click #designerToolbar':'designerToolbar',
            'click #designerPropertyBar':'designerPropertyBar',
            'click #designerHelpCenter':'designerHelpCenter',
            'click #pf-close-main-view':'closeForm'
        };

        this.model.set('helpUrl', constants.HELP_URL);
        this.model.set('isForm', listService.docType === constants.DOC_TYPE_FORM, {silent:true});
        this.listenTo(this.model, 'change', this.render);

        super.initialize(opts);
        this.setOptions();

        return this;
    }

    setOptions(){
        this.model.set('helpUrl', constants.HELP_URL, {silent:true});
        this.model.set('designerSnapToGrid', userService.userSettings.attributes._edAl !== '0');
        this.model.set('hideGrid', !util.isTrue(userService.userSettings.attributes._edShGrid));
        this.model.set('designerSnapTextToNeighbor', util.isTrue(userService.userSettings.attributes._edShWfM));
        this.model.set('designerWorkflowMarkers', util.isTrue(userService.userSettings.attributes[constants.WORKFLOW_MARKERS]), {silent: true});
    }

    //================================================================================
    // Saves the current layout editor form, as defined by listService atate
    //================================================================================



    close() {
        if(undoService.hasChanges()) {
            let closeFormConfirmationModalView = new CloseFormConfirmationModalView({
                model: new Model({
                    confirmationText: `Would you like to save the changes you made to this app?`,
                    height: 140,
                    width: 500
                })
            });
            closeFormConfirmationModalView.render().then((result) => {
                switch (result) {
                    case 'Yes':
                        listService.linkClicked = true;
                        Backbone.history.loadUrl('saveAndClose');
                        break;
                    case 'No':
                        listService.linkClicked = true;
                        Backbone.history.loadUrl('close');
                        break;
                    default:
                        break;
                }
            }).catch((err) => {
                console.log('Error Showing Save App Confirmation Modal', err);
                notificationService.error('Error Showing Save App Confirmation Modal ' + err.MESSAGE);
            });
        }
        else{
            listService.linkClicked = true;
            Backbone.history.loadUrl('close');
        }
    }

    closeForm(ev){
        if (undoService.hasChanges()) { 
            ev.preventDefault();
            ev.returnValue = false; 
            util.removeIfRemainingHelpCenter();                       
            formService.confirmSaveOnClose(); 
        }
        else {
            ev.preventDefault();
            ev.returnValue = false;              
            util.removeIfRemainingHelpCenter();    
            Backbone.history.loadUrl('close');
        }
    }
    showGrid(){
        // TODO get gridsize from properties
        eventBus.trigger('gridSizeSet', ($('#designerGrid').html() === 'Hide Grid') ? 0 : 20);
        // if ($('#designerGrid').html() === 'Hide Grid') {
        //     eventBus.trigger('gridSizeSet', 0);
        //     $('#designerGrid').html('Show Grid');
        // } else {
        //     eventBus.trigger('gridSizeSet', 20);
        //     $('#designerGrid').html('Hide Grid');
        // }
        pageCaptureController.captureThumbnail();
    }

    gotoEditor() {
        Backbone.history.loadUrl('edit');
    }

    gotoBehaviors() {
        Backbone.history.loadUrl('behaviors');
    }

    gotoWorkflow() {
        Backbone.history.loadUrl('workflow');
    }

    copyItem() {
        crudController.copySelectedBehaviors();
    }

    pasteItem() {
        listService.fcanvas.deactivateAll().renderAll();
        crudController.pasteSelectedBehaviors();
    }

    cutItem() {
        crudController.cutSelectedBehaviors();
    }

    deleteItem() {
        crudController.deleteSelectedBehaviors();
    }

    selectAll(evt) {
        evt.preventDefault();
        objectUtil.selectAllCanvasObjects();
    }

    // =============
    // Align options menu
    // =============
    
    alignTopHandler(evt) {
        evt.preventDefault();
        alignmentController.canvasAlignTop( listService.fcanvas.getObjects() );
    }
    alignRightHandler(evt) {
        evt.preventDefault();
        alignmentController.canvasAlignRight( listService.fcanvas.getObjects() );
    }
    alignBottomHandler(evt) {
        evt.preventDefault();
        alignmentController.canvasAlignBottom( listService.fcanvas.getObjects() );
    }
    alignLeftHandler(evt) {
        evt.preventDefault();
        alignmentController.canvasAlignLeft( listService.fcanvas.getObjects() );
    }

    alignVerticalCenterHandler( evt ) {
        evt.preventDefault();
        alignmentController.canvasAlignCenter( constants.ALIGN_VERTICAL, listService.fcanvas.getObjects() );
    }
    alignHorizontalCenterHandler( evt ) {
        evt.preventDefault();
        alignmentController.canvasAlignCenter( constants.ALIGN_HORIZONTAL, listService.fcanvas.getObjects() );
    }

    // =============
    // Make same options menu
    // PF-2320: Placeholder methods for when the resize is implemented on behaviors+workflows
    // =============
    makeSameWidthHandler( evt ) {
        evt.preventDefault();
    }
    makeSameHeightHandler( evt ) {
        evt.preventDefault();
    }
    makeSameSizeHandler( evt ) {
        evt.preventDefault();
    }

    // =============
    // Space evently options menu
    // =============
    spaceEvenlyAcrossHandler( evt ) {
        evt.preventDefault();
        alignmentController.canvasSpaceEvenly( constants.EVENLY_ACROSS, listService.fcanvas.getObjects() );
    }
    spaceEvenlyDownHandler( evt ) {
        evt.preventDefault();
        alignmentController.canvasSpaceEvenly( constants.EVENLY_DOWN, listService.fcanvas.getObjects() );
    }
    spaceEvenlyBothHandler( evt ) {
        evt.preventDefault();
        alignmentController.canvasSpaceEvenly( constants.EVENLY_ACROSS, listService.fcanvas.getObjects() );
        alignmentController.canvasSpaceEvenly( constants.EVENLY_DOWN, listService.fcanvas.getObjects() );
    }

    // =============
    // View Menu
    // =============
    toggleGridVisibility(event){
        let currentElement=$(event.target);
        if (currentElement.parent().html().includes('Off')) {
            userService.userSettings.attributes._edShGrid = false;
            eventBus.trigger('gridSizeSet', false);
            currentElement.parent().html(`<a  id="hideGrid">Grid - On</a>`);
        } else {
            userService.userSettings.attributes._edShGrid = true;
            eventBus.trigger('gridSizeSet', true);  // TODO No hardcoding. Use and form gridWidth and gridHeight
            currentElement.parent().html(`<a  id="hideGrid"> Grid - Off</a>`);
        }
        pageCaptureController.captureThumbnail();
    }

    designerNonVisualObjects() {
        this.toggleMenuStatusText(event,'Non-Visual Objects');
    }

    designerWorkflowMarkers() {
        this.toggleMenuStatusText(event,'Workflow Markers');
        userService.userSettings.attributes[constants.WORKFLOW_MARKERS] = !userService.userSettings.attributes[constants.WORKFLOW_MARKERS];
    }

    designerObjectMarkers() {
        this.toggleMenuStatusText(event,'Object Markers');
    }
    
    toggleSnapToGrid(event) {
        const $menuItem = $( '#designerSnapToGrid' ), prfSet = 'Set', prfReset = 'Reset';
        userService.userSettings.attributes._edAl = userService.userSettings.attributes._edAl === '0' ? '1' : '0';
        
        listService.snapToGrid = userService.userSettings.attributes._edAl === '0' ? false : true;
        this.model.set('designerSnapToGrid', listService.snapToGrid, {silent:true});
        $menuItem.html(`${listService.snapToGrid ? prfSet : prfReset } Snap-to-Grid -${listService.snapToGrid ? "On": "Off"}`);
    }

    designerSnapTextToNeighbor() {
        this.toggleMenuStatusText(event,'Snap Text to Neighbor');
        userService.userSettings.attributes._edShWfM = !listService.snapToNeighbor;
        listService.snapToNeighbor=!listService.snapToNeighbor;
    }

    designerToolbar() {
        this.toggleMenuStatusText(event,'Toolbar');
    }

    designerPropertyBar() {
        this.toggleMenuStatusText(event,'Property Bar');
    }

    designerHelpCenter() {
        let view =  new HelpCenterView( {model: new Model() } );
        view.render();
    }
    
    toggleMenuStatusText(event,text){
        let currentElement=$(event.target);
        if (currentElement.parent().html().includes('Off')) {
            this.model.set(currentElement.attr('id'), true, {silent: true});
            currentElement.parent().html(`<a  id="${currentElement.attr('id')}">${text} - On</a>`);
        }
        else {
            this.model.set(currentElement.attr('id'), false, {silent: true});
            currentElement.parent().html(`<a  id="${currentElement.attr('id')}">${text} - Off</a>`);
        }
    }

    render() {
        this.$el.empty();
        this.$el.html(this.template(this.model.toJSON()));

        // Enabling Submenu Functionality
        $('[data-submenu]').submenupicker();

        if (listService.docType === constants.DOC_TYPE_REPORT) {
            $('#reportMenu').removeClass('hide');
        } else if (listService.docType === constants.DOC_TYPE_FORM) {
            $('#fileMenu').removeClass('hide');
        }

        $('#align').addClass('disabled pf-disable');
        $('#makeSame').addClass('disabled pf-disable');
        $('#spaceEvenly').addClass('disabled pf-disable');
        $('#layer').addClass('disabled pf-disable');
        $('#behaviorAddGroup').addClass('disabled pf-disable');

        this.delegateEvents();
        return this;
    }

    remove() {
        this.undelegateEvents();
        this.stopListening();
        this.$el.empty();
        super.remove();
    }
}

export default BehaviorMenuView;
